import React from "react";
import { isoOrderID } from "tsi-common-react/src/models/nominals";
import { dynamicPlaceComponent } from "tsi-common-react/src/utils/react";

dynamicPlaceComponent(
    '[data-place-react="order-cancel-button"]',
    async (elem) => {
        const { OrderCancelButton } = await import(
            "tsi-common-react/src/apps/orders/OrderCancelButton"
        );
        const orderID = parseInt(elem.dataset.order || "", 10);
        if (!orderID) {
            return null;
        }
        return <OrderCancelButton orderID={isoOrderID.wrap(orderID)} />;
    },
).catch(console.error);

// Render Order Details Tracker Modal
dynamicPlaceComponent(
    '[data-place-react="order-detail-tracker-modal"]',
    async (elem) => {
        const { OrderDetailsTrackerModal } = await import(
            "tsi-common-react/src/apps/orders/OrderDetailsTrackerModal"
        );
        const orderTrackerModalData = JSON.parse(elem.dataset.cms || "null");
        const currentStep = elem.dataset.currentStep;
        const shippingMethod = elem.dataset.shippingMethod;
        const deliverySteps =
            // TODO(i18n): Use t tagged template for comparison: shippingMethod === t`White Glove Delivery`
            shippingMethod === "White Glove Delivery"
                ? orderTrackerModalData.freight_delivery_steps
                : orderTrackerModalData.small_package_delivery_steps;
        const modalHead =
            // TODO(i18n): Use t tagged template for comparison and values: t`White Glove Delivery` and t`UPS Delivery`
            shippingMethod === "White Glove Delivery"
                ? shippingMethod
                : "UPS Delivery";
        return (
            <OrderDetailsTrackerModal
                deliverySteps={deliverySteps}
                modalHead={modalHead}
                modalSubHead={
                    orderTrackerModalData.order_detail_tracker_modal_delivery_explanation
                }
                currentStep={currentStep}
            />
        );
    },
).catch(console.error);
